/**
 * 区域管理
 */
<template>
  <div>
    <div style="margin: 20px">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/dispatch/dispatch_mn' }">调度计划</el-breadcrumb-item>
        <el-breadcrumb-item>调度任务</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 搜索筛选 -->
      <div>
        <el-form :inline="true" :model="formInline" style="margin-top: 20px; heigth: 60px" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="任务名称:">
                <el-input placeholder="请输入任务名称" v-model="formInline.task_name" clearable size="small" style="width:300px">
                </el-input>
              </el-form-item>
              <el-form-item label="创建人:">
                <el-select size="small" clearable filterable v-model="formInline.userId" placeholder="请选择创建人"
                  style="width:300px">
                  <el-option v-for="item in planCreatorOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <div>
                <el-form-item label="负责人:">
                  <el-select size="small" clearable filterable v-model="formInline.head" placeholder="请选择负责人"
                    style="width:300px">
                    <el-option v-for="item in planHeadOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="押车人:">
                  <el-select size="small" clearable filterable v-model="formInline.escortPerson" placeholder="请选择押车人"
                    style="width:300px">
                    <el-option v-for="item in PlanEscortOptions" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div>
                <el-form-item label="调度地:">
                  <el-cascader v-model="task_start_place_id" size="small " :options="planStartPlaceOptions"
                    style="width:300px" :show-all-levels="false" :props="{ checkStrictly: true }" clearable>
                  </el-cascader>
                </el-form-item>
                <el-form-item label="目的地:">
                  <el-cascader v-model="task_end_place_id" size="small " :options="planEndPlaceOptions"
                    style="width:300px" :show-all-levels="false" :props="{ checkStrictly: true }" clearable>
                  </el-cascader>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div>
                <el-form-item label="任务状态:">
                  <el-select size="small" clearable filterable v-model="formInline.status" placeholder="请选择任务状态"
                    style="width:300px">
                    <el-option v-for="item in planStatusOptions" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="创建时间:">
                  <div class="block">
                    <el-date-picker size="small" v-model="formInline.create_time" value-format="yyyy-MM-dd" type="date"
                      style="width:300px" placeholder="选择创建时间">
                    </el-date-picker>
                  </div>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button size="small" type="success" icon="el-icon-plus" @click="addDispatchTask()"
                    v-if="check_auth('/web/schedule_task/add')">
                    添加任务
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button size="small" type="primary" @click="exportSelect()"
                    v-if="check_auth('/web/schedule_task/export')">导出</el-button>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!--列表-->
      <div style="margin-top: 20px">
        <el-table :data="listData" border element-loading-text="拼命加载中" style="width: 100%" ref="multipleTable"
          @selection-change="handleSelectionChange" row-key="id">
          <el-table-column type="selection" reserve-selection align="center" width="55">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="id" label="ID" width="80"></el-table-column>
          <el-table-column align="center" label-aligin="center" prop="vin" min-width="200" label="车辆编号">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="taskName" min-width="200" label="调度任务">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="startPlaceStr" min-width="200" label="调度地">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="endPlaceStr" min-width="200" label="目的地">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="userCustomer.name" label="创建人" min-width="150">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="headUser.name" label="负责人" min-width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.headUser">{{ scope.row.headUser.name }}</div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="escortPersonUserStr" label="押车人" min-width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.escortPersonUserStr">{{ scope.row.escortPersonUserStr }}</div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="taskStartTimeStr" min-width="200" label="任务开始时间">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="taskEndTimeStr" min-width="200" label="任务完成时间">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="actualStartTimeStr" min-width="200" label="实际开始时间">
            <template slot-scope="scope">
              <div v-if="scope.row.actualStartTimeStr">{{ scope.row.actualStartTimeStr }}</div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="actualEndTimeStr" min-width="200" label="实际完成时间">
            <template slot-scope="scope">
              <div v-if="scope.row.actualEndTimeStr">{{ scope.row.actualEndTimeStr }}</div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="taskStatusStr" width="200" label="计划状态">
            <template slot-scope="scope">
              <el-tag :color="scope.row.taskStatus_type" style="color:white">{{
                scope.row.taskStatus
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label-aligin="center" label="操作" fixed="right" width="250"
            v-if="check_auth('/web/schedule_task/update') || check_auth('/web/schedule_task/delete') || check_auth('/web/schedule_task/undo')">
            <template slot-scope="scope">
              <el-button round size="mini" @click="editDispatchTask(scope.row)" :disabled="scope.row.taskStatus !== '未开始'"
                v-if="check_auth('/web/schedule_task/update')">编辑</el-button>
              <el-button round size="mini" type="danger" @click="delDispatchTask(scope.row)"
                :disabled="scope.row.taskStatus !== '未开始'" v-if="check_auth('/web/schedule_task/delete')">删除</el-button>
              <el-button round type="warning" size="mini" @click="undoDispatchTask(scope.row)"
                :disabled="scope.row.taskStatus == '已撤销'" v-if="check_auth('/web/schedule_task/undo')">撤销</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      <!-- 添加界面 -->
      <el-dialog :title="addtitle" :visible.sync="addFormVisible" width="35%" @close="closeDialog"
        :destroy-on-close="true" :close-on-click-modal="false">
        <el-form label-width="17%" :model="addForm" :rules="rules" ref="addForm">
          <el-form-item label="车辆编号" prop="vin">
            <el-select size="small" clearable filterable v-model="addForm.vin" :disabled="disabled" style="width: 100%"
              placeholder="请选择车辆编号">
              <el-option v-for="item in addPlanCarOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label-width="110px" label="创建人" prop="userId">
              <el-select
                size="small"
                clearable
                filterable
                style="width: 100%"
                v-model="addForm.userId"
                placeholder="请选择创建人"
              >
                <el-option
                  v-for="item in addPlanCreatorOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                                              </el-option>
                                            </el-select>
                                          </el-form-item> -->
          <el-form-item label="任务名称" prop="task_name">
            <el-input size="small" v-model="addForm.task_name" clearable auto-complete="off" style="width: 100%"
              placeholder="请输入任务名称"></el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="head">
            <el-select size="small" clearable filterable v-model="addForm.head" style="width: 100%" placeholder="请选择负责人">
              <el-option v-for="item in addPlanHeadOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="押车人" prop="escortPerson">
            <el-select size="small" clearable filterable style="width: 100%" v-model="addForm.escortPerson"
              placeholder="请选择押车人">
              <el-option v-for="item in addPlanEscortOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="调度地" prop="addStartPlaceId">
            <el-cascader v-model="addForm.addStartPlaceId" size="small" style="width: 100%"
              :options="addPlanStartPlaceOptions" :show-all-levels="false" :props="{ checkStrictly: true }" clearable>
            </el-cascader>
          </el-form-item>
          <el-form-item label="目的地" prop="addEndPlaceId">
            <el-cascader v-model="addForm.addEndPlaceId" size="small" style="width: 100%"
              :options="addPlanEndPlaceOptions" :show-all-levels="false" :props="{ checkStrictly: true }" clearable>
            </el-cascader>
          </el-form-item>
          <el-form-item label="开始结束时间" prop="time_upend">
            <div class="block">
              <el-date-picker size="small" clearable style="width: 100%" v-model="addForm.time_upend"
                value-format="yyyy-MM-dd HH:mm:ss" :default-time="['08:00:00', '17:00:00']" type="datetimerange"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" :loading="loading" class="addtitle" @click="submitAdd('addForm')">保存
          </el-button>
          <el-button size="mini" @click="closeDialog('addForm')">取消</el-button>
        </div>
      </el-dialog>
      <!-- 编辑界面 -->
      <el-dialog :title="edittitle" :visible.sync="editFormVisible" width="35%" @close="closeDialog"
        :destroy-on-close="true" :close-on-click-modal="false">
        <el-form label-width="17%" :model="editForm" :rules="rules" ref="editForm">
          <el-form-item label="车辆编号" prop="vin">
            <el-select size="small" clearable filterable v-model="editForm.vin" :disabled="disabled" style="width: 100%"
              placeholder="请选择车辆编号">
              <el-option v-for="item in editPlanCarOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label-width="110px" label="创建人" prop="userId">
              <el-select
                size="small"
                clearable
                filterable
                style="width: 100%"
                v-model="editForm.userId"
                placeholder="请选择创建人"
              >
                <el-option
                  v-for="item in editPlanCreatorOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                                              </el-option>
                                            </el-select>
                                          </el-form-item> -->
          <el-form-item label="任务名称" prop="taskName">
            <el-input size="small" v-model="editForm.taskName" auto-complete="off" style="width: 100%"
              placeholder="请输入任务名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="head">
            <el-select size="small" clearable filterable v-model="editForm.head" style="width: 100%" placeholder="请选择负责人">
              <el-option v-for="item in editPlanHeadOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="押车人" prop="escortPerson">
            <el-select size="small" clearable filterable style="width: 100%" v-model="editForm.escortPerson"
              placeholder="请选择押车人">
              <el-option v-for="item in editPlanEscortOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="调度地" prop="editStartPlaceId">
            <el-cascader v-model="editForm.editStartPlaceId" size="small" style="width: 100%" clearable
              :options="editPlanStartPlaceOptions" :show-all-levels="false" :props="{ checkStrictly: true }">
            </el-cascader>
          </el-form-item>
          <el-form-item label="目的地" prop="editEndPlaceId">
            <el-cascader v-model="editForm.editEndPlaceId" size="small" style="width: 100%" clearable
              :options="editPlanEndPlaceOptions" :show-all-levels="false" :props="{ checkStrictly: true }">
            </el-cascader>
          </el-form-item>
          <el-form-item label="开始结束时间" prop="time_upend">
            <div class="block">
              <el-date-picker size="small" clearable style="width: 100%" v-model="editForm.time_upend"
                value-format="yyyy-MM-dd HH:mm:ss" :default-time="['08:00:00', '17:00:00']" type="datetimerange"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" :loading="loading" class="edittitle" @click="submitForm('editForm')">
            保存</el-button>
          <el-button size="mini" @click="closeDialog('editForm')">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  get_dispatch_task_list,
  get_dispatch_get_car_task,
  get_planHead_list,
  get_taskCar_list,
  get_cloudPlatformAreaSummaryNoParent_list,
  get_dispatch_task_add,
  get_dispatch_task_del,
  get_dispatch_task_undo,
  get_export_dispatch_task,
  get_dispatch_task_one,
  get_dispatch_task_edit,
} from "../../api/dispatch/dispatch_task";
import Pagination from "../../components/Pagination";
import {
  auth
} from "../../utils/util";
export default {
  data() {
    return {
      editFormVisible: false, //控制编辑页面显示与隐藏
      addFormVisible: false,
      loading: false, //是显示加载
      planStatusOptions: [
        {
          value: 0,
          label: "未开始",
        },
        {
          value: 1,
          label: "进行中",
        },
        {
          value: 2,
          label: "已完成",
        },
        {
          value: 3,
          label: "已撤销",
        },
      ],
      idsval: [],
      ids: [],
      disabled: false,
      planCreatorOptions: [],
      planHeadOptions: [],
      PlanEscortOptions: [],
      task_start_place_id: [],
      planStartPlaceOptions: [],
      task_end_place_id: [],
      planEndPlaceOptions: [],
      addtitle: "添加",
      //添加下拉列表
      addPlanCarOptions: [],
      // addPlanCreatorOptions: [],
      addPlanHeadOptions: [],
      addPlanEscortOptions: [],
      addPlanStartPlaceOptions: [],
      addPlanEndPlaceOptions: [],
      edittitle: "修改",
      //编辑下拉列表
      editPlanCarOptions: [],
      // editPlanCreatorOptions: [],
      editPlanHeadOptions: [],
      editPlanEscortOptions: [],
      editPlanStartPlaceOptions: [],
      editPlanEndPlaceOptions: [],
      addForm: {
        id: "",
        vin: "",
        task_name: "",
        userId: "",
        startPlaceId: "",
        addStartPlaceId: [],
        endPlaceId: "",
        addEndPlaceId: [],
        head: "",
        escortPerson: "",
        time_upend: [],
      },
      editForm: {
        id: "",
        vin: "",
        taskName: "",
        userId: "",
        startPlaceId: "",
        endPlaceId: "",
        editStartPlaceId: [],
        editEndPlaceId: [],
        head: "",
        escortPerson: "",
        time_upend: [],
      },
      // rules表单验证
      rules: {
        vin: [{ required: true, message: "请选择车辆编号", trigger: "change" }],
        task_name: [
          { required: true, message: "请输入计划名称", trigger: "blur" },
        ],
        head: [{ required: true, message: "请选择负责人", trigger: "change" }],
        time_upend: [
          {
            required: true,
            message: "请选择开始和结束时间",
            trigger: "change",
          },
        ],
        userId: [{ required: true, message: "请选择创建人", trigger: "blur" }],
        addStartPlaceId: [
          { required: true, message: "请选择调度地", trigger: "change" },
        ],
        addEndPlaceId: [
          {
            required: true,
            message: "请选择目的地",
            trigger: "change",
          },
        ],
        editStartPlaceId: [
          { required: true, message: "请选择调度地", trigger: "change" },
        ],
        editEndPlaceId: [
          {
            required: true,
            message: "请选择目的地",
            trigger: "change",
          },
        ],
        escortPerson: [
          {
            required: true,
            message: "请选择押运人",
            trigger: "change",
          },
        ],
      },
      formInline: {
        id: "",
        vin: "",
        task_name: "",
        userId: "",
        head: "",
        task_start_place_id: "",
        task_end_place_id: "",
        escortPerson: "",
        status: "",
        create_time: "",
        page: 1,
        limit: 10,
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      listData: [],
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getData();
    this.getPlanCreator();
    this.getPlanHead();
    this.getPlanEscort();
    this.getStartPlaceList();
    this.getEndPlaceList();
  },
  props: {
    vin: String,
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    check_auth(val) {
      return auth(val);
    },
    // 创建人列表
    getPlanCreator() {
      get_planHead_list().then((res) => {
        if (res["code"] === 0) {
          this.planCreatorOptions = res.data;
        }
      });
    },
    // 负责人列表
    getPlanHead() {
      get_planHead_list().then((res) => {
        if (res["code"] === 0) {
          this.planHeadOptions = res.data;
        }
      });
    },
    // 押运人列表
    getPlanEscort() {
      get_planHead_list().then((res) => {
        if (res["code"] === 0) {
          this.PlanEscortOptions = res.data;
        }
      });
    },
    // 调度地列表
    getStartPlaceList() {
      get_cloudPlatformAreaSummaryNoParent_list().then((res) => {
        if (res["code"] === 0) {
          this.planStartPlaceOptions = res.data;
        }
      });
    },
    // 目的地列表
    getEndPlaceList() {
      get_cloudPlatformAreaSummaryNoParent_list().then((res) => {
        if (res["code"] === 0) {
          this.planEndPlaceOptions = res.data;
        }
      });
    },
    // 事故列表
    getData() {
      this.formInline.vin = this.vin == undefined ? "" : this.vin;
      this.show = this.vin == undefined ? true : false;
      if (this.show) {
        get_dispatch_task_list(this.formInline).then((res) => {
          if (res["code"] === 0) {
            this.listData = res.data.list;
            for (let i = 0; i < this.listData.length; i++) {
              this.listData[i].taskStatus_type = {
                "0": "#909399",
                "1": "#409EFF",
                "2": "#F56C6C",
                "3": "#E6A23C",
              }[this.listData[i].taskStatus];
              this.listData[i].taskStatus = {
                "0": "未开始",
                "1": "进行中",
                "2": "已结束",
                "3": "已撤销"
              }[this.listData[i].taskStatus];
            }
            this.pageparm.total = res.data.count;
          }
        });
      } else {
        get_dispatch_get_car_task(this.formInline).then((res) => {
          if (res["code"] === 0) {
            this.listData = res.data.list;
            for (let i = 0; i < this.listData.length; i++) {
              this.listData[i].taskStatus_type = {
                "0": "#909399",
                "1": "#409EFF",
                "2": "#F56C6C",
                "3": "#E6A23C",
              }[this.listData[i].taskStatus];
              this.listData[i].taskStatus = {
                "0": "未开始",
                "1": "进行中",
                "2": "已结束",
                "3": "已撤销"
              }[this.listData[i].taskStatus];
            }
            this.pageparm.total = res.data.count;
          }
        });
      }
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getData();
    },
    // 搜索事件
    search() {
      this.formInline.task_start_place_id = "";
      this.formInline.task_end_place_id = "";
      for (let i = 0; i < this.task_start_place_id.length; i++) {
        this.formInline.task_start_place_id =
          this.task_start_place_id[this.task_start_place_id.length - 1];
      }
      for (let i = 0; i < this.task_end_place_id.length; i++) {
        this.formInline.task_end_place_id =
          this.task_end_place_id[this.task_end_place_id.length - 1];
      }
      this.formInline.page = 1;
      this.getData();
    },
    // 添加  车辆列表
    getAddCar() {
      get_taskCar_list().then((res) => {
        if (res["code"] === 0) {
          this.addPlanCarOptions = res.data;
        }
      });
    },
    //  添加 负责人列表
    getAddPlanHead() {
      get_planHead_list().then((res) => {
        if (res["code"] === 0) {
          this.addPlanHeadOptions = res.data;
        }
      });
    },
    // //  添加 创建人列表
    // getAddPlanCreator() {
    //   get_planHead_list().then((res) => {
    //     if (res["code"] === 0) {
    //       this.addPlanCreatorOptions = res.data;
    //     }
    //   });
    // },
    //  添加 押运人列表
    getAddPlanEscort() {
      get_planHead_list().then((res) => {
        if (res["code"] === 0) {
          this.addPlanEscortOptions = res.data;
        }
      });
    },
    // 添加 调度地列表
    getAddStartPlaceList() {
      get_cloudPlatformAreaSummaryNoParent_list().then((res) => {
        if (res["code"] === 0) {
          this.addPlanStartPlaceOptions = res.data;
        }
      });
    },
    // 添加 目的地列表
    getAddEndPlaceList() {
      get_cloudPlatformAreaSummaryNoParent_list().then((res) => {
        if (res["code"] === 0) {
          this.addPlanEndPlaceOptions = res.data;
        }
      });
    },
    //显示添加界面
    addDispatchTask() {
      this.addFormVisible = true;
      this.addForm = {};
      // this.addStartPlaceId = [];
      // this.addEndPlaceId = [];
      this.getAddPlanHead();
      this.getAddCar();
      // this.getAddPlanCreator();
      this.getAddPlanEscort();
      this.getAddStartPlaceList();
      this.getAddEndPlaceList();
      if (this.vin == undefined) {
        this.disabled = false;
      } else {
        this.disabled = true;
        this.addForm.vin = this.vin;
      }
    },
    // 添加信息
    submitAdd(addData) {
      this.addForm.startPlaceId =
        this.addForm.addStartPlaceId == undefined
          ? ""
          : this.addForm.addStartPlaceId[
          this.addForm.addStartPlaceId.length - 1
          ];
      this.addForm.endPlaceId =
        this.addForm.addEndPlaceId == undefined
          ? ""
          : this.addForm.addEndPlaceId[this.addForm.addEndPlaceId.length - 1];

      this.$refs[addData].validate((valid) => {
        if (valid) {
          get_dispatch_task_add(this.addForm).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              this.addFormVisible = false;
              this.getData();
              this.addForm = {};
            }
          });
        } else {
          return false;
        }
      });
    },
    // 编辑  车辆列表
    getEditAddCar() {
      get_taskCar_list().then((res) => {
        if (res["code"] === 0) {
          this.editPlanCarOptions = res.data;
        }
      });
    },
    // 编辑 负责人列表
    getEditPlanHead() {
      get_planHead_list().then((res) => {
        if (res["code"] === 0) {
          this.editPlanHeadOptions = res.data;
        }
      });
    },
    // 编辑 创建人列表
    // getEditPlanCreator() {
    //   get_planHead_list().then((res) => {
    //     if (res["code"] === 0) {
    //       this.editPlanCreatorOptions = res.data;
    //     }
    //   });
    // },
    // 编辑 押运人列表
    getEditPlanEscort() {
      get_planHead_list().then((res) => {
        if (res["code"] === 0) {
          this.editPlanEscortOptions = res.data;
        }
      });
    },
    // 编辑 调度地列表
    getEditStartPlaceList() {
      get_cloudPlatformAreaSummaryNoParent_list().then((res) => {
        if (res["code"] === 0) {
          this.editPlanStartPlaceOptions = res.data;
        }
      });
    },
    // 编辑 目的地列表
    getEditEndPlaceList() {
      get_cloudPlatformAreaSummaryNoParent_list().then((res) => {
        if (res["code"] === 0) {
          this.editPlanEndPlaceOptions = res.data;
        }
      });
    },
    //显示编辑界面
    editDispatchTask(row) {
      this.edittitle = "修改";
      this.editForm.editStartPlaceId = [];
      this.editForm.editEndPlaceId = [];
      this.getEditAddCar();
      // this.getEditPlanCreator();
      this.getEditPlanHead();
      this.getEditPlanEscort();
      this.getEditStartPlaceList();
      this.getEditEndPlaceList();
      if (this.vin == undefined) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
      get_dispatch_task_one(row.id).then((res) => {
        if (res["code"] === 0) {
          this.editForm = res.data;
          this.editForm.editStartPlaceId = res.data.startPlaceArr;
          this.editForm.editEndPlaceId = res.data.endPlaceIdArr;
          this.editFormVisible = true;
          this.$set(this.editForm, "time_upend", [
            res.data.taskStartTimeStr,
            res.data.taskEndTimeStr,
          ]);
        }
      });
    },
    // 修改保存
    submitForm(editData) {
      this.editForm.startPlaceId =
        this.editForm.editStartPlaceId == undefined
          ? ""
          : this.editForm.editStartPlaceId[
          this.editForm.editStartPlaceId.length - 1
          ];
      this.editForm.endPlaceId =
        this.editForm.editEndPlaceId == undefined
          ? ""
          : this.editForm.editEndPlaceId[
          this.editForm.editEndPlaceId.length - 1
          ];
      this.$refs[editData].validate((valid) => {
        if (valid) {
          get_dispatch_task_edit(this.editForm).then((res) => {
            this.editFormVisible = false;
            if (res["code"] === 0) {
              this.getData();
              this.$message.success(res["message"]);
            }
          });
        } else {
          return false;
        }
      });
    },

    // 撤销调度任务
    undoDispatchTask(row) {
      this.$confirm("即将强制撤销任务，请确认！", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          get_dispatch_task_undo(row.id).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              if (this.listData.length === 1) {
                if (this.formInline.page === 1) {
                  this.getData();
                } else {
                  this.formInline.page = this.formInline.page - 1;
                  this.getData();
                }
              } else {
                this.getData();
              }
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 删除
    delDispatchTask(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          get_dispatch_task_del(row.id).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              if (this.listData.length === 1) {
                if (this.formInline.page === 1) {
                  this.getData();
                } else {
                  this.formInline.page = this.formInline.page - 1;
                  this.getData();
                }
              } else {
                this.getData();
              }
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 导出
    getExport(id) {
      get_export_dispatch_task(id)
        .then((res) => {
          if (res["code"] == undefined) {
            // 这里根据后端返回使用res或res.data
            var blob = new Blob([res], {
              type: "application/ms-excel",
            });
            var elink = document.createElement("a");
            elink.download = "调度任务" + ".xlsx";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click(); //点击下载
            URL.revokeObjectURL(elink); //释放掉blob对象
            document.body.removeChild(elink); //下载完成移除元素
          }
        })
        .catch((err) => {
          this.$notify.error({
            title: "提示",
            message: err.message,
          });
        });
    },
    //导入车辆id
    handleSelectionChange(val) {
      this.idsval = [];
      for (let i in val) {
        //去重以免发生意外的push
        if (!this.idsval.includes(val[i])) {
          this.idsval.push(val[i]);
        }
      }
    },
    toggleRowSelect() {
      this.$nextTick(() => {
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection();
        }
      });
    },
    exportSelect() {
      for (var i = 0; i < this.idsval.length; i++) {
        this.ids.push(this.idsval[i].id);
      }
      var str = this.ids.join(",");
      if (this.idsval.length > 0) {
        this.getExport(str);
      } else {
        this.$message.error("下载失败，先选择需要下载的数据");
      }
      this.toggleRowSelect();
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false;
      this.addFormVisible = false;
    },
  },
};
</script>

<style scoped>
.close {
  width: 1.5%;
  height: 2.5%;
  position: absolute;
  top: 8%;
  left: 97%;
}

.el-input--small {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/dispatch/dispatch_task.vue